import { LineItem } from 'shared/types/cart';

export const hasBundleId = (lineItems: LineItem[]): boolean =>
  lineItems.some(({ bundleId }) => bundleId);

export const getBundleId = (lineItems: LineItem[]): string | undefined =>
  lineItems.find(({ bundleId }) => bundleId)?.bundleId;
